import React from "react";
import EmbraceLogo from "../Common/EmbraceLogo";

const PrivacyPolicy = () => {
  return (
    <div style={{ height: "100vh", width: "100vw", overflow: "auto" }}>
      <div
        style={{
          padding: "40px",
          maxWidth: "1000px",
          margin: "0 auto",
          fontFamily: "Arial, sans-serif",
          color: "#333",
          lineHeight: "1.5",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
          <EmbraceLogo sx={{ height: { xs: 40, md: 44 } }} />
        </div>
        <h1 style={{ textAlign: "center", marginBottom: "30px" }}>
          Política de privacidad
        </h1>

        <section>
          <p>
            Los datos recopilados a través de la aplicación del estudio, el reloj inteligente, el
            monitor continuo de glucosa (MCG) y los registros de salud electrónicos (incluyendo
            actividad física, frecuencia cardíaca, sueño, glucosa y datos clínicos) se compartirán
            de forma segura con King's College London (Reino Unido) y la Fundación para la Formación
            e Investigación Sanitaria (FFIS, España) con fines de investigación, en el marco de este
            estudio.
          </p>
        </section>

        <section style={{ marginTop: "20px" }}>
          <p>
            La FFIS y King's College London actúan como corresponsables del tratamiento de estos
            datos. King's College London trata esta información al amparo del artículo 6(1)(e) del UK
            GDPR (tarea de interés público) y del artículo 9(2)(j) (investigación científica).
          </p>
        </section>

        <section style={{ marginTop: "20px" }}>
          <p>
            En la medida de lo posible, sus datos serán seudonimizados o anonimizados antes de ser
            compartidos. Algunos datos anonimizados podrán también compartirse con Garmin
            International, Inc. con fines de colaboración en investigación y para la mejora de las
            tecnologías de dispositivos. Garmin no recibirá ningún dato personal identificable, y no
            compartiremos con dicha empresa ningún dato que pueda vincularse a usted como individuo.
          </p>
        </section>

        <section style={{ marginTop: "20px" }}>
          <p>
            Para obtener información completa sobre el estudio y sus derechos, consulte la Hoja de
            Información para el Participante o diríjase al equipo del estudio.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
